import React, { ReactElement } from 'react';

import COLORS from '~/constants/colors';
import Header from '~/components/titles/Header';
import Subheader from '~/components/titles/Subheader';
import Divider from '~/components/flow/Divider';
import Break from '~/components/flow/Break';

import Container from '../../components/Container';
import Form from './components/Form';

function Decode(): ReactElement {
  // Styling
  const headerStyle = {
    margin: 0,
  };
  const doNotStyle = {
    color: COLORS.mandy,
  };

  return (
    <Container>
      <Header style={headerStyle}>Decode</Header>
      <Divider />
      <Subheader>
        Please <b style={doNotStyle}>do not</b> toss your computer out the
        window
      </Subheader>
      <Break />
      <Form />
    </Container>
  );
}

export default Decode;
